import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'crm-call-log-details',
  templateUrl: './call-log-details.component.html',
  styleUrls: ['./call-log-details.component.scss']
})
export class CallLogDetailsComponent implements OnInit {
  leadCalllogDetails:any;
  constructor() { }

  ngOnInit() {
  }

}
